import React from "react";
import Select from "react-select";

const options = [
  { label: "Open to invest in all sectors", value: "open-to-all" },
  { label: "AdTech", value: "adtech" },
  { label: "Agritech", value: "agritech" },
  { label: "Artificial Intelligence", value: "artificial-intelligence" },
  { label: "Blockchain", value: "blockchain" },
  { label: "ClimateTech", value: "climatetech" },
  { label: "Cybersecurity", value: "cybersecurity" },
  { label: "DeepTech", value: "deeptech" },
  { label: "EdTech", value: "edtech" },
  { label: "E-commerce", value: "e-commerce" },
  { label: "EnergyTech", value: "energytech" },
  { label: "FinTech", value: "fintech" },
  { label: "FoodTech", value: "foodtech" },
  { label: "Gaming and Esports", value: "gaming-esports" },
  { label: "HealthTech", value: "healthtech" },
  { label: "HRTech", value: "hrtech" },
  { label: "InsurTech", value: "insurtech" },
  { label: "Internet of Things (IoT)", value: "iot" },
  { label: "LegalTech", value: "legaltech" },
  { label: "Logistics", value: "logistics" },
  { label: "MarTech (Marketing Technology)", value: "martech" },
  { label: "Marketplace Platforms", value: "marketplace-platforms" },
  { label: "Media and Entertainment", value: "media-entertainment" },
  { label: "Mobility", value: "mobility" },
  { label: "PropTech (Real Estate Tech)", value: "proptech" },
  { label: "RetailTech", value: "retailtech" },
  { label: "SaaS (Software as a Service)", value: "saas" },
  { label: "Social Impact", value: "social-impact" },
  { label: "SportsTech", value: "sportstech" },
  { label: "Travel and Tourism", value: "travel-tourism" },
 
];

const StartupSectorDropdown = ({ value, onChange }) => {
  return (
    <div className="input-group">
      <label className="input-label" htmlFor="startupsector">
        Preferred Sectors* <span className="optional-label">(You can choose multiple values)</span>
      </label>
      <Select
        options={options}
        isMulti
        
        value={options.filter(option => value.includes(option.value))} // Ensure proper value binding
        onChange={(selectedOptions) => {
          const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
          onChange(selectedValues);
        }}
        placeholder="Select preferred sectors..."
        styles={{
          control: (provided) => ({
            ...provided,
            borderRadius: "6px",
            padding: "5px",
            marginTop: "5px",
            border: "1px solid #7C8594",
          }),
        }}
      />
    </div>
  );
};

export default StartupSectorDropdown;
